import React, {Component} from 'react';
import PropTypes from "prop-types"
import "../util.scss"

class BaseLayout extends Component {

   render() {
      return (
         <div>
            <div id="page-wrap" className="wrapper-wide ">
                  {this.props.children}
            </div>
         </div>
      )
   }
}

BaseLayout.propTypes = {
   children: PropTypes.any
}


export default BaseLayout



// WEBPACK FOOTER //
// ./src/layout/EmptyLayout.js